import { useState } from 'react';
import { useAuth } from '../provider';
interface FetchState<T> {
    data: T | null;
    loading: boolean;
    error: Error | null;
    get: (payload?: string, append?: boolean) => Promise<T>; // Modified signature to accept optional string payload
    post: (payload: any) => Promise<any>;
    setPayloadUrl: (url: string) => void; // Function to set the payload URL
}

const useFetch = <T>(url: string): [T | null, FetchState<T>] => {
    const [data, setData] = useState<T | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<Error | null>(null);
    const [, setPayloadUrl] = useState<string | null>(null);
    const { getAuthHeaders } = useAuth();
    let authHeaders = getAuthHeaders();
    const get = async (payload?: string, append: boolean = false): Promise<T> => {
        // Modified signature
        setLoading(true);
        setError(null);
        let requestUrl = url; // Default to the base URL
        if (payload) {
            if (append) {
                requestUrl = `${url}${payload}`; // Append payload to the URL
                console.log(requestUrl);
            }
            if (!append) {
                requestUrl = `${url}?${payload}`; // Append payload as query parameters
            }
        }

        try {
            const response = await fetch(requestUrl, {
                // Use the potentially modified URL
                method: 'GET',
                headers: {
                    ...authHeaders,
                    'Content-Type': 'application/json',
                },
            });
            const result: T = await response.json();
            setData(result);
            return result;
        } catch (err) {
            setError(err as Error);
        } finally {
            setLoading(false);
        }
        const result: T = null as T;
        return result;
    };

    const post = async (payload: any): Promise<any> => {
        setError(null);
        try {
            setLoading(true);
            let authHeaders = getAuthHeaders();
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    ...authHeaders,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });
            setLoading(false);
            return await response.json();
        } catch (err) {
            setLoading(false);
            setError(err as Error);
        }
    };

    return [data, { get, post, loading, error, data: data, setPayloadUrl: setPayloadUrl }]; // Return the state and functions
};

export default useFetch;
